﻿$(function () {
    $.Product = {
        init: function (id) {
            $.Cart.refreshCounters();
        }
    }
});